import { collapsedStyles } from '../consts';
import { TransitionMap } from '../types';

export const createTransitionMap = ({
  desktopDefaultStyles,
  mobileDefaultStyles,
  desktopSupportWindowStyles,
  mobileSupportWindowStyles,
}: {
  desktopDefaultStyles: Record<string, unknown>;
  mobileDefaultStyles: Record<string, unknown>;
  desktopSupportWindowStyles: Record<string, unknown>;
  mobileSupportWindowStyles: Record<string, unknown>;
}): TransitionMap => {
  return {
    FAB: {
      hide: {
        startTransitionMessageType: { type: 'hide-fab' },
        completeTransitionMessageType: { type: 'hide-fab-transition-complete' },
      },
      FIC: {
        show: {
          startTransitionMessageType: { type: 'show-fic' },
          completeTransitionMessageType: { type: 'show-fic-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    FIC: {
      hide: {
        startTransitionMessageType: { type: 'hide-fic' },
        completeTransitionMessageType: { type: 'hide-fic-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
          ...collapsedStyles,
        }),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    WINDOW: {
      hide: {
        startTransitionMessageType: { type: 'hide-support-window' },
        completeTransitionMessageType: { type: 'hide-support-window-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
          ...collapsedStyles,
        }),
      },
      FIC: {
        show: {
          startTransitionMessageType: { type: 'show-fic' },
          completeTransitionMessageType: { type: 'show-fic-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
        }),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    HIDDEN: {
      hide: {
        startTransitionMessageType: { type: 'show-hidden' },
        completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
          ...collapsedStyles,
        }),
      },
      FIC: {
        show: {
          startTransitionMessageType: { type: 'show-fic' },
          completeTransitionMessageType: { type: 'show-fic-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
        }),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
    },
  };
};
